<template>
  <article
    :class="{
      'min-h-300 rounded-2xl p-3 pb-2 flex flex-col gap-2 transition-shadow duration-300 hover:elevation-2 hover:transition-shadow hover:duration-300': true,
      'elevation-1 surface1 hover:surface2': isElevated,
      'border border-outline/16 p-4 bg-surface': isOutlined,
      'bg-surface-variant text-on-surface-variant': isFilled,
      'bg-surface text-on-surface': isSurface,
    }"
  >
    <div class="flex flex-col gap-2 items-start justify-between">
      <p v-if="!showCompany" class="label-sm text-left">Publicado el {{ parsed_published_at }}</p>
      <h3 class="font-sans font-medium title-lg text-left md:headline-5 ">
        {{ offer.title }}
      </h3>
      <div v-if="showCompany" class="flex flex-row gap-2 items-center justify-left">
        <ProfilePicture
          v-if="offer.company.profile_image"
          :src="offer.company.profile_image"
          size="extra-small"
          class="cursor-pointer"
          with-border
        />
        <div class="flex flex-col">
          <p class="title-sm text-primary cursor-pointer">
            <!-- TODO: Add link to offer.company.profile_url -->
            {{ offer.company.name }}
          </p>
          <p class="label-sm text-on-surface-variant text-left">
            Publicado el {{ parsed_published_at }}
          </p>
        </div>
      </div>
    </div>
  </article>
</template>

<script>
import ProfilePicture from '@/Components/ProfilePicture'
import ChipListItem from '@/Components/ChipListItem'
import Button from '@/Components/Button'
import Icon from '@/Components/Icon'
import { validateRequiredKeys } from '@/utilities.helpers.js'

export default {
  name: 'OfferCard',
  components: { ProfilePicture, Button, ChipListItem, Icon },
  props: {
    elevated: { type: Boolean, default: true },
    outlined: { type: Boolean, default: false },
    filled: { type: Boolean, default: false },
    surface: { type: Boolean, default: false },
    withButton: {
      type: Boolean,
      required: false,
      default: false,
    },
    showChips: {
      type: Boolean,
      required: false,
      default: false,
    },
    showCompany: {
      type: Boolean,
      required: false,
      default: false,
    },
    offer: {
      type: Object,
      required: true,
      validator: function(value) {
        let requiredKeys = ['published_at', 'title', 'description']
        return validateRequiredKeys(value, requiredKeys)
      },
    },
  },
  computed: {
    isElevated() {
      return this.filled || this.outlined || this.surface ? false : true
    },
    isFilled() {
      return this.isElevated || this.outlined || this.surface ? false : true
    },
    isOutlined() {
      return this.isElevated || this.filled || this.surface ? false : true
    },
    isSurface() {
      return this.isElevated || this.filled || this.outlined ? false : true
    },
    parsed_published_at() {
      let publicationdate = this.offer.published_at.slice(0, this.offer.published_at.length - 9);
      const date = new Date(publicationdate);
      return `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`
    },
    salaryChipLabel() {
      if (this.offer.salary.to_be_agreed) return 'Salario a convenir'
      else if (this.offer.salary.max) return `${this.offer.salary.min} - ${this.offer.salary.max}`
      else return this.offer.salary.min
    },
  },
}
</script>

<style></style>
